import { Component, OnInit, AfterContentInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgxPermissionsObject, NgxPermissionsService } from 'ngx-permissions';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { EntitiesEnum } from '@enums/entities.enum';
import {remainingTrialDays} from '@utilities/function-utils'
import { WidgetsFacadeService } from '@services/widgets/widgets-facade.service';
import { BusinessModel } from '@models/business.model';
import { ResellerModel } from '@models/reseller.model';
import { LocationModel } from '@models/locations.model';

@Component({
  selector: 'card-profile-2',
  templateUrl: './card-profile.component.html',
  styleUrls: ['./card-profile.component.sass']
})
export class CardProfile2Component implements OnInit, AfterContentInit {
  @Input() entity: EntitiesEnum;
  @Input() model: ResellerModel | BusinessModel;
  @Input() showDelete: boolean = false;
  @Input() showDetails: boolean = false;
  @Input() showMobileHeading: boolean = false;
  @Output() edit = new EventEmitter<ResellerModel | BusinessModel | LocationModel>();
  @Output() delete = new EventEmitter<ResellerModel | BusinessModel | LocationModel>();

  //@Output() archive = new EventEmitter();
  //@Output() reviwTargets = new EventEmitter();
  //@Output() openZapier = new EventEmitter();

  entitiesEnum = EntitiesEnum;
  permissions: NgxPermissionsObject;
  landing$ = this.widgetsFacadeService.getLoctionGenericLanding$();
  optinUrl$: Observable<Object[]> = this.locationsFacadeService.getUrls$();
  optinUrl: string

  constructor(
    private permissionsService: NgxPermissionsService,
    private locationsFacadeService: LocationsFacadeService,
    private widgetsFacadeService: WidgetsFacadeService,
    private window: Window,
  ) { }

  ngOnInit() {
    this.permissions = this.permissionsService.getPermissions();
    // this.locationsFacadeService.searchUrls(this.id)
    //this.widgetsFacadeService.getLoctionGenericLanding();
  }

  ngAfterContentInit() {
    this.optinUrl$.pipe(
      map(url => url[0] ? url[0]['key'] : '')
    ).subscribe(value => { this.optinUrl = value })
  }

  copyUrl(urlElement) {
    let range = new Range();
    range.setStart(urlElement, 0);
    range.setEnd(urlElement, 1);
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(range);
    document.execCommand('copy');
  }

  daysTrial(){
    if (this.entity == EntitiesEnum.Business) {
      return remainingTrialDays(
        this.window.moment((this.model as BusinessModel).trialEndDate).startOf('day').unix(),
        this.window.moment(this.window.moment.now()).startOf('day').unix()
      )
    } else {
      return 0
    }
  }

  editClicked(event: Event) {
    event.stopPropagation();
    this.edit.emit(this.model);
  }

  deleteClicked(event: Event) {
    event.stopPropagation();
    this.delete.emit(this.model);
  }
}
